import { Box, Button, Stack } from "@mui/material";
import { useEffect, useState } from "react";
import InvirteLogo from "../images/invirte-logo.png";
import { buttonChangeStyle } from "../styles";
import { Link, redirect, useLocation, useNavigate } from "react-router-dom";
import useApi from "../hooks/useApi";
import SnackAlert from "./SnackAlert";
import useSnack from "../hooks/useSnack";

function AuthPanel({ Login, Register }) {
  const [showPassword, setShowPassword] = useState(false);
  const changePasswordVisibility = () => {
    setShowPassword(showPassword ? false : true);
  };
  const { msgSB, openSB, showSnack, typeSB } = useSnack();

  const navigate = useNavigate();
  const location = useLocation();

  useEffect(() => {
    if (location.pathname === "/login") {
      if (location.search === "?verifyemail=success") {
        navigate("/verified");
      }
    }
  }, []);

  return (
    <>
      <Stack
        component="main"
        sx={{
          overflow: { xs: "auto", lg: "hidden" },
          width: "100%",
          height: "100vh",
          justifyContent: "space-between",
          flexDirection: {
            xs: "column",
            lg: location.pathname === "/register" ? "row-reverse" : "row",
          },
        }}
      >
        <Stack
          component="section"
          sx={{
            backgroundColor: "primary.main",
            width: {
              xs: "100%",
              lg: "50%",
            },
            height: {
              xs: "30vh",
              lg: "100%",
            },
            display: "grid",
            placeContent: "center",
          }}
        >
          <Box sx={{ width: { xs: 220, lg: 487, sm: 260, md: 250 } }}>
            <img src={InvirteLogo} alt="Invirte Bussiness" width="100%" />
          </Box>
        </Stack>
        <Stack
          component="section"
          sx={{
            py: {
              xs: 2,
              sm: 5,
              lg: 3,
            },
            width: {
              xs: "100%",
              lg: "50%",
            },
            height: {
              xs: "100vh",
              lg: "100%",
            },
            alignItems: "center",
            justifyContent: {
              xs: "flex-start",
              lg: "center",
            },
          }}
        >
          <Box
            sx={{
              mx: "auto",
              borderRadius: 5,
              mb: { xs: 2, lg: 5 },
              width: "fit-content",
              overflow: "hidden",
              display: "flex",
            }}
          >
            <Button
              LinkComponent={Link}
              to={"/login"}
              sx={{
                ...buttonChangeStyle,
                minWidth: {
                  xs: 100,
                  lg: 150,
                },
                backgroundColor:
                  location.pathname === "/register"
                    ? "secondary.main"
                    : "primary.main",
                color: location.pathname === "/register" ? "black" : "white",
                "&:hover": {
                  backgroundColor:
                    location.pathname === "/register"
                      ? "secondary.300"
                      : "primary.300",
                },
              }}
            >
              Iniciar
            </Button>
            <Button
              LinkComponent={Link}
              to={"/register"}
              sx={{
                ...buttonChangeStyle,
                minWidth: {
                  xs: 100,
                  lg: 150,
                },
                backgroundColor:
                  location.pathname === "/register"
                    ? "primary.main"
                    : "secondary.main",
                color:
                  location.pathname === "/register" ? "white" : "secondary",
                "&:hover": {
                  backgroundColor:
                    location.pathname === "/register"
                      ? "primary.300"
                      : "secondary.300",
                },
              }}
            >
              Registrar
            </Button>
          </Box>

          {location.pathname === "/login" ? (
            <Login
              showPassword={showPassword}
              changePasswordVisibility={changePasswordVisibility}
            />
          ) : (
            <Register
              showPassword={showPassword}
              changePasswordVisibility={changePasswordVisibility}
            />
          )}
        </Stack>
      </Stack>
      <SnackAlert openSB={openSB} typeSB={typeSB} msgSB={msgSB} />
    </>
  );
}

export default AuthPanel;
